import React from 'react'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { connect } from 'dva'
import { PositionRadar } from '@/components'
import { Table } from 'antd'

let { WizContainer, modelUtils } = framework_tool
let { WizSpin, WizCard } = component_tool
let { Session } = utils_tool

const findParamRecord = (history) => {
    let record = {}
    if (history.location && history.location.pathname === '/remoteAuth/nevRemoteAuthDetailList/score') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('competencyCertificationModel', record)
        } else {
            record = Session.get('competencyCertificationModel') || {}
        }
    }
    return record
}

class CompetencyCertificationModel extends WizContainer {
    componentName = 'CompetencyCertificationModel'

    constructor(props) {
        super(props)
        let record = findParamRecord(props.history)
        this.state = {
            record
        }
    }

    _componentDidMount() {
        this.doAction({
            path: 'nevRemoteAuthDetail/competencyCertificationModel',
            payload: {
                key: 'competencyCertificationModel',
                apiParams: { id: this.state.record.id }
            }
        })
    }

    _data = ({ infoList = [] }) => {
        let r = {
            data: [],
            dataFormat: {
                type: 'fold',
                fields: ['score'],
                key: 'user',
                value: 'score'
            },
            cols: {
                score: {
                    min: 0,
                    max: 100,
                    tickInterval: 10 //用于指定坐标轴各个标度点的间距，是原始数据之间的间距差值
                },
                user: {
                    formatter: val => '能力认证模块得分'
                },
            },
            colors: ['#ed7d31']
        }
        let data = []
        infoList && infoList.length && infoList.forEach(item => {
            let { moduleName, abilityScore } = item
            data.push({
                item: moduleName || '',
                score: abilityScore || 0
            })
        })
        r.data = data
        return r
    }

    _render() {
        let { result = {}, nevRemoteAuthDetailLoading } = this.props
        let radarProps = {
            key: 'radar',
            radarProps: this._data(result),
            other: {
                style: {
                    border: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }
            }
        }

        let columns = [{
            title: '',
            name: 'moduleName',
            dataIndex: 'moduleName',
            align: 'center',
        }, {
            title: '能力标准',
            name: 'abilityTotalScore',
            dataIndex: 'abilityTotalScore',
            align: 'center'
        }, {
            title: '学员达成',
            name: 'abilityScore',
            dataIndex: 'abilityScore',
            align: 'center'
        }, {
            title: '分模块得分',
            name: 'moduleScore',
            dataIndex: 'moduleScore',
            align: 'center'
        }, {
            title: '分模块标准',
            name: 'moduleTotalScore',
            dataIndex: 'moduleTotalScore',
            align: 'center'
        }]

        let tableProps = {
            columns,
            dataSource: result.infoList || [],
            pagination: false,
            bordered: true,
            rowKey: 'id',
            style: {
                marginTop: 30,
                marginBottom: 100
            }
        }
        return (
            <WizSpin spinning={nevRemoteAuthDetailLoading} >
                <WizCard className='competency-certification-model' title='能力认证模型'>
                    {radarProps.radarProps.data.length ? <PositionRadar {...radarProps} /> : null}
                    <Table {...tableProps} />
                </WizCard>
            </WizSpin>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { nevRemoteAuthDetail } = state
    const result = modelUtils.getModelEntity(nevRemoteAuthDetail, 'competencyCertificationModel')
    const load = modelUtils.getLoadingState(state, ['nevRemoteAuthDetail'])
    return {
        result: result.data,
        ...load
    }
}

export default connect(mapStateToProps)(CompetencyCertificationModel)

